import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/entity/$entityId/')({
  beforeLoad: ({ params: { entityId }, context: { entityType, scopedEnablements, scope } }) => {
    if (entityType) {
      const enablements = scopedEnablements.for(scope)
      if (entityType.useDetailsAsLandingPage === true) {
        throw redirect({
          to: '/entity/$entityId/details',
          params: { entityId },
          replace: true,
          search: true,
        })
      }
      if (enablements.hasStandardEnablement('SummaryDashboard', 'READ')) {
        throw redirect({
          to: '/entity/$entityId/summary',
          params: { entityId },
          replace: true,
          search: true,
        })
      } else if (enablements.hasStandardEnablement('Exploration', 'READ')) {
        throw redirect({
          to: '/entity/$entityId/exploration',
          params: { entityId },
          replace: true,
          search: true,
        })
      }
    }

    throw redirect({
      to: '/entity/$entityId/details',
      params: { entityId },
      replace: true,
      search: true,
    })
  },
})
